import styled from "styled-components";

/* ── Avatar Circle ── */

export const AvatarCircle = styled.div`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  background: ${({ $bg }) => $bg};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ $size }) => $size * 0.36}px;
  font-weight: 700;
  font-family: var(--font-sans);
  border: 2px solid #fff;
  flex-shrink: 0;
  cursor: default;
  user-select: none;
`;

export const AvatarBadge = styled.div`
  position: absolute;
  bottom: -3px;
  right: -4px;
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  border-radius: 7px;
  background: #1e293b;
  color: #fff;
  font-size: 8.5px;
  font-weight: 800;
  line-height: 14px;
  text-align: center;
  border: 1.5px solid #fff;
  font-family: var(--font-mono);
`;

export const AvatarTooltip = styled.div`
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  background: #1e293b;
  color: #fff;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 11px;
  font-weight: 600;
  font-family: var(--font-sans);
  white-space: nowrap;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  pointer-events: none;
`;

export const TooltipName = styled.div``;

export const TooltipEmail = styled.div`
  font-size: 10px;
  color: #94a3b8;
  margin-top: 2px;
`;

export const TooltipArrow = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #1e293b;
`;

export const AvatarWrapper = styled.div`
  position: relative;
  display: inline-block;
  margin-left: ${({ $overlap }) => ($overlap ? -7 : 0)}px;
  z-index: ${({ $hovered }) => ($hovered ? 10 : 1)};
`;

/* ── Dropdown ── */

export const DropdownContainer = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: ${({ $width }) => $width}px;
  background: var(--surface);
  border: 1.5px solid var(--rule);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  padding: 8px;
`;

export const DropdownSearch = styled.input`
  width: 100%;
  padding: 6px 8px;
  font-size: 11px;
  border-radius: 6px;
  border: 1px solid var(--rule);
  margin-bottom: 6px;
  font-family: var(--font-sans);
  outline: none;
`;

export const DropdownList = styled.div`
  max-height: 180px;
  overflow-y: auto;
`;

export const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  border-radius: 6px;
`;

export const DropdownItemName = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: var(--ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DropdownItemMeta = styled.div`
  font-size: 10px;
  color: var(--accent);
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DropdownItemEmail = styled.div`
  font-size: 10px;
  color: var(--ink-4);
  font-family: var(--font-mono);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DropdownEmpty = styled.div`
  padding: 12px 8px;
  font-size: 11px;
  color: var(--ink-4);
  text-align: center;
`;

/* ── AvatarGroup cell wrapper ── */

export const GroupCellWrapper = styled.div`
  width: ${({ $width }) => $width}px;
  flex-shrink: 0;
  padding: 12px 10px;
  position: relative;
`;

export const GroupEmptyWrapper = styled.div`
  width: ${({ $width }) => $width}px;
  flex-shrink: 0;
  padding: 14px 10px;
`;

export const GroupEmptyLabel = styled.span`
  font-size: 11px;
  color: ${({ $isError }) => ($isError ? "var(--amber-700, #b45309)" : "var(--ink-4)")};
  font-style: italic;
`;

export const GroupRow = styled.div`
  display: flex;
  align-items: center;
`;

export const OverflowBubble = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #f1f5f9;
  border: 2px solid #fff;
  margin-left: -7px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9.5px;
  font-weight: 700;
  color: var(--ink-3);
  cursor: default;
`;
